import Vue from "vue"
import config from '../config'

export default {
    update(body, params = {}){
        return Vue.http.patch(config.apiBaseUrl + '/companies', body, { params }).then((response) => response.json());
    },

    setCompanySettings(body, params = {}) {
        return Vue.http.post(config.apiBaseUrl + '/companies/company-settings', body, { params }).then((response) => response.json())
    },

    createCompany(body, params = {}) {
        return Vue.http.post(config.apiBaseUrl + '/companies/generate-company-and-dependecies', body, { params }).then((response) => response.json())
    },

    getList(params = {}) {
        return Vue.http.get(config.apiBaseUrl + '/companies', { params }).then((response) => response.json());
    },

    getCompany(companyId, params = {}) {
        return Vue.http.get(config.apiBaseUrl + '/companies/' + companyId, { params }).then((response) => response.json())
    },

    getActivityArea(companyId, params = {}) {
        return Vue.http.get(config.apiBaseUrl + '/companies/' + companyId + '/activity-area', { params }).then((response) => response.json())
    }
}
